import { defkey } from './constants';
import { CustomSerializer } from './custom-serializer';
import { SchemaInstance, SchemaWithDefinitions } from './types';

export function findDuplicatesOn<T>(arr: T[], accessor: (item: T) => any): T[] {
	return arr.reduce<T[]>((acc, item, index) => {
		const value = accessor(item);
		const firstIndex = arr.findIndex((i) => accessor(i) === value);

		if (firstIndex !== index && !acc.some((i) => accessor(i) === value)) {
			return [...acc, value];
		}

		return acc;
	}, []);
}

export function isSchema(target: any): target is SchemaWithDefinitions {
	return defkey in target;
}

export function isSchemaInstance(target: any): target is SchemaInstance {
	return target && isSchema(target.constructor);
}

export function isSerializer(target: any): target is new (...args: any[]) => CustomSerializer {
	return target.prototype instanceof CustomSerializer;
}

export function getDef(schema: SchemaWithDefinitions) {
	return schema[defkey];
}

export function isPresent<T>(value: T | null | undefined): value is T {
	return value !== null && value !== undefined;
}

export function arrayTypesMatch(a: any, b: any) {
	return Array.isArray(a) === Array.isArray(b);
}
